import { IStudentRow } from 'types';
import { IOption } from 'shared-components';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UNI_ROLES, UserRole } from '@/store/auth/types';
import { ActionSelection } from '../../../types';

export const getAssignVisaSupportOptions = (
  userRole: UserRole,
  manualVisaSupportEnabled: boolean,
  isPathwayProvider: boolean,
  selectedRows: string[],
  visibleStudents: IStudentRow[],
): Array<IOption> => {
  const options: Array<IOption> = [];

  const oneRecordSelected = selectedRows.length === 1;
  const selectedStudents = visibleStudents?.filter(value => selectedRows.indexOf(value.p_key) > -1) ?? [];

  // If user is Direct Uni, do not allow any options for pathway students.
  const isDirectUniUser = !isPathwayProvider && UNI_ROLES.includes(userRole);
  const isPathwayStudent = !!selectedStudents[0]?.pathway;
  const isVisaSupportAssigned = selectedStudents[0]?.visaSupport;
  const directUniUserCondition = isDirectUniUser ? !isPathwayStudent : true;

  if (oneRecordSelected && manualVisaSupportEnabled && directUniUserCondition) {
    if (hasPerm(userRole, P.ASSIGN_VISA_SUPPORT) && !isVisaSupportAssigned) {
      options.push({
        label: 'Assign visa support',
        value: ActionSelection.ASSIGN_VISA_SUPPORT,
      });
    }

    if (hasPerm(userRole, P.UNASSIGN_VISA_SUPPORT) && isVisaSupportAssigned) {
      options.push({
        label: 'Unassign from visa support',
        value: ActionSelection.UNASSIGN_VISA_SUPPORT,
      });
    }
  }

  return options;
};
